import React from 'react';
import { connect } from 'react-redux';

import init from './methods/init.ts';
import questionHandler from './methods/questionHandler.ts';

import FaqI from './types.ts';

import renderQuestions from './renders/renderQuestions.tsx';
import questions from './static/questions.ts';

class Faq extends React.Component<FaqI['props'], FaqI['state']> implements FaqI {
    parent: FaqI['parent'];

    constructor(props: FaqI['props']) {
        super(props);
        this.state = {
            currentQuestion: 0,
            heights: {},
        };

        this.parent = React.createRef();
    }

    questions = questions;

    renderQuestions = renderQuestions;

    questionHandler = questionHandler;
    init = init;

    componentDidMount(): void {
        this.init();
    }

    render() {
        return (
            <section ref={this.parent} className="publicExecutorsFaq">
                <div className="publicExecutorsFaq__inner">
                    <div className="publicExecutorsFaq__head _col">
                        <div className="publicExecutorsFaq__title">Вопросы и ответы</div>
                        <p className="publicExecutorsFaq__description">
                            Узнайте всё, что вас интересует —<br />
                            кликните на вопрос, чтобы развернуть ответ
                        </p>
                    </div>
                    {this.renderQuestions()}
                </div>
            </section>
        );
    }
}

function mapStateToProps() {
    return {};
}

export default connect(mapStateToProps)(Faq);
